module.exports = __webpack_public_path__ + "img/kc3.69f555bb.png";